import PropTypes from 'prop-types';
import { Box, Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { userWritePermission } from '../../../store/selectors/account.selector';
import decOfNum from '../../../utils/decOfNum';

const DepartmentsMulti = ({
  departmentsActive,
  departmentsDeleteClick,
  ...props
}) => {
  const editPermission = useSelector(userWritePermission);

  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mb: 3,
        }}
      >
        {editPermission && !!departmentsActive && (
          <Button
            sx={{ ml: 1 }}
            color="secondary"
            variant="contained"
            onClick={() => departmentsDeleteClick()}
          >
            Удалить&nbsp;
            { departmentsActive }
            &nbsp;
            { decOfNum(departmentsActive, ['отдел', 'отдела', 'отделов']) }
          </Button>
        )}
      </Box>
    </Box>
  );
};

DepartmentsMulti.propTypes = {
  departmentsActive: PropTypes.number,
  departmentsDeleteClick: PropTypes.func,
};

DepartmentsMulti.defaultProps = {
  departmentsActive: 0,
  departmentsDeleteClick: null,
};

export default DepartmentsMulti;
